<template>
  <div class="pie">
    <div id="controllerItems" :style="{width: width, height: height}" ></div>
  </div>
</template>

<script>
  import {errorHandler} from '../../../../utils/errorHandler'
  import {api} from '../../../../view/api/ElectronicManagement'

  export default {
    name: 'controller-pie',
    props: {
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '240px'
        }
      },
      buildingCode: {
        type: String,
        default () {
          return ''
        }
      }
    },
    data () {
      return {
        chartText: '集中器',
        tipData: ['在线', '离线'],
        chartData: [],
        totalCount: ''
      }
    },
    created () {},
    mounted () {
      this.getElectricManagerList()
    },
    methods: {
      // 集中器
      getElectricManagerList () {
        let buildingCode = ''
        if (this.buildingCode !== '0') {
          buildingCode = this.buildingCode
        }
        this.$axios.post(api.getElectricControlDeviceOverview, {
          buildingCode: buildingCode
        })
          .then(res => {
            let data = res.data.data
            let onLine = {value: data.onlineCount || 0, name: '在线'}
            let offLine = {value: data.offlineCount || 0, name: '离线'}
            this.chartData = [onLine, offLine]
            this.totalCount = data.totalCount
            this.drawPie()
          })
          .catch(errorHandler('获取集中器数据失败'))
      },
      drawPie () {
        let controllerItems = this.$echarts.init(document.getElementById('controllerItems'))
        controllerItems.setOption({
          title : {
            text: `${this.chartText}(${this.totalCount})`,
            // subtext: '',
            x:'center'
          },
          tooltip : {
            trigger: 'item',
            formatter (data) {
              return `${data.name}:${data.value}(${data.percent.toFixed(0)}%)`
            },
            // formatter: "{b} : {c} ({d}%)"
          },
          legend: {
            left: 'center',
            bottom: -5,
          },
          color: ['#44c23b', '#f54659'],
          series : [
            {
              name: '集中器',
              type: 'pie',
              radius: ['40%', '60%'],
              data: this.chartData,
              label: {
                normal: {
                  show: false,
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: '12',
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        });

      },
    },
    watch: {
      buildingCode () {
        this.getElectricManagerList()
      }
    }
  }
</script>

<style scoped>
  .pie {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Pie/Pie/controllerPie.vue